<template>
  <div class="sort">
    <div class="toolbar">
      <div
        :class="{ newarray: !start, disable: start }"
        @click="getArray(valeur)"
      >
        New Array
      </div>
      <div class="separator"></div>
      <div class="sizespeed">
        <input
          type="range"
          id="changeSize"
          name="changeSize"
          min="1"
          max="100"
          :disabled="start"
          v-model="valeur"
        />
        <label for="changeSize">Change Array Size &amp; Sorting Speed</label>
      </div>
      <div class="separator"></div>
      <div
        :class="{ merge: true, active: getbool('merge') }"
        @click="setMethode('merge')"
      >
        Tri Fusion
      </div>
      <div
        :class="{ quick: true, active: getbool('quick') }"
        @click="setMethode('quick')"
      >
        Tri Rapide
      </div>
      <div
        :class="{ heap: true, active: getbool('heap') }"
        @click="setMethode('heap')"
      >
        Tri par Tas
      </div>
      <div
        :class="{ bubble: true, active: getbool('bubble') }"
        @click="setMethode('bubble')"
      >
        Tri à Bulles
      </div>
      <div class="separator"></div>
      <div :class="{ start: !start, disable: start }" @click="sort()">
        Sort!
      </div>
    </div>
    <div class="content">
      <div
        v-for="(d, index) in this.array"
        class="arrayElement"
        :key="index"
        :style="{
          height: `${d}px`,
          width: width,
          margin: `0px ${margin}`,
          backgroundColor: 'rgba(66, 134, 244, 0.8)',
          color: color,
          fontSize: fontSize,
        }"
      >
        {{ d }}
      </div>
    </div>
    
  </div>
</template>

<script>
import {getMergeSort} from "./Algorithms/merge.js";
import {iterativeQuickSort} from "./Algorithms/quick.js";
import {getHeapSort} from "./Algorithms/heap.js";
import {getbubbleSort} from "./Algorithms/bubble.js";
export default {
  name: "Sort",
  data: () => ({
    array: [],
    start: false,
    valeur: 2,
    currrentMethode: "",
    width:"",
    margin:"",
    color:"",
    fontSize:"",
    animations:[]
  }),
  watch: {
    valeur: function () {
      this.getArray(this.valeur);
      const numWidth = Math.floor(document.querySelector('.content').clientWidth / (this.array.length * 3));
      this.width = `${numWidth}px`;
      const numMargin = this.array.length < 2 ?
        8 : this.array.length < 4 ?
          6 : this.array.length < 8 ?
            4 : this.array.length < 10 ?
              2 : this.array.length < 15 ?
                1.5 : this.array.length < 20 ?
                  1.5 : this.array.length < 30 ?
                    1.5 : 1;
      this.margin = `${numMargin}px`;
      this.color = numWidth > 20 ? "white" : "transparent";
      const numFont = numWidth > 70 ?
        20 : numWidth > 60 ?
          18 : numWidth > 50 ?
            16 : numWidth > 40 ?
              14 : numWidth > 30 ?
                12 : numWidth > 20 ?
                  10 : 8;
      this.fontSize = `${numFont}px`
    },
  },
  methods: {
    sort() {
      this.start = !this.start;
      switch(this.currrentMethode){
        case 'merge':this.mergeSort(); break;
        case'quick':this.quickSort(); break;
        case 'heap':this.heapSort(); break;
        case 'bubble':this.bubbleSort(); break;
        default:this.start=false;break;
      }
      
    },
    setMethode(e) {
      this.currrentMethode = e;
    },
    getbool(e) {
      return this.currrentMethode === e;
    },
    getArray(e) {
      if(!this.start){
        let h = document.querySelector(".content").clientHeight;
        this.array = Array.from(
          { length: e },
          () => Math.floor(Math.random() * (h - 50 + 1)) + 50
        );
        const divs=document.querySelectorAll('.arrayElement');
        divs.forEach((div,index)=>{
          div.innerText=`${this.array[index]}`
          div.style.backgroundColor= 'rgba(66, 134, 244, 0.8)';
        })
      }
    },
    mergeSort() {
      this.animations=[];
      let clone=this.array.slice();
      clone=getMergeSort(clone,this.animations);
      let speed= this.valeur > 25 ? this.valeur*10/2 : this.valeur;
      for(let i =0; i<this.animations.length;i++){
        const div=document.querySelectorAll('.arrayElement');
        const isColorChange = i % 3 !== 2;
        if (isColorChange) {
          const [barOneIdx, barTwoIdx] = this.animations[i];
          const barOneStyle = div[barOneIdx].style;
          const barTwoStyle = div[barTwoIdx].style;
          const color = i % 3 === 0 ? 'red' : 'turquoise';
          setTimeout(() => {
            barOneStyle.backgroundColor = color;
            barTwoStyle.backgroundColor = color;
          }, (i*1500)/speed);
        } else {
          setTimeout(() => {
            const [barOneIdx, newHeight] = this.animations[i];
            const barOneStyle = div[barOneIdx].style;
            div[barOneIdx].innerText=`${newHeight}`;
            barOneStyle.height = `${newHeight}px`;
          }, (i*1500)/speed);
        }
      }
      setTimeout(()=>{
        this.array=clone;
        this.start=false;
      },(this.animations.length*1500)/speed)
    },
    quickSort(){
      this.animations=[];
      let clone=this.array.slice();
      iterativeQuickSort(clone,this.animations);
      let speed= this.valeur > 25 ? this.valeur*10/2 : this.valeur;
      for(let i =0; i<this.animations.length;i++){
        const div=document.querySelectorAll('.arrayElement');
        const isColorChange = this.animations[i].length!==3;
        if (isColorChange) {
          const [barOneIdx, barTwoIdx] = this.animations[i];
          const barOneStyle = div[barOneIdx].style;
          const barTwoStyle = div[barTwoIdx].style;
          const color = this.animations[i][2] ? 'red' : 'turquoise';
          setTimeout(() => {
            barOneStyle.backgroundColor = color;
            barTwoStyle.backgroundColor = color;
          }, (i*1500)/speed);
        } else {
          setTimeout(() => {
            const [barOneIdx, barTwoIdx] = this.animations[i];
            const [swap1, newHeight1] = barOneIdx;
            const [swap2, newHeight2] = barTwoIdx;
            const barOneStyle = div[swap1];
            const barTwoStyle = div[swap2];
            barOneStyle.innerText = `${newHeight1}`;
            barTwoStyle.innerText = `${newHeight2}`;
            barOneStyle.style.height = `${newHeight1}px`;
            barTwoStyle.style.height = `${newHeight2}px`;
          }, (i*1500)/speed);
        }
      }
      setTimeout(()=>{
        this.array=clone;
        this.start=false;
      },(this.animations.length*1500)/speed)
    },
    heapSort(){
      this.animations=[];
      let clone=this.array.slice();
      getHeapSort(clone,this.animations);
      let speed= this.valeur > 25 ? 550 : this.valeur;
      for(let i =0; i<this.animations.length;i++){
        const div=document.querySelectorAll('.arrayElement');
        const isColorChange = this.animations[i].length!==2;
        if (isColorChange) {
          const [barOneIdx, barTwoIdx] = this.animations[i];
          const barOneStyle = div[barOneIdx].style;
          const barTwoStyle = div[barTwoIdx].style;
          const color = this.animations[i][2] ? 'red' : 'turquoise';
          setTimeout(() => {
            barOneStyle.backgroundColor = color;
            barTwoStyle.backgroundColor = color;
          }, (i*1500)/speed);
        } else {
          setTimeout(() => {
            const [barOneIdx, barTwoIdx] = this.animations[i];
            const [swap1, newHeight1] = barOneIdx;
            const [swap2, newHeight2] = barTwoIdx;
            const barOneStyle = div[swap1];
            const barTwoStyle = div[swap2];
            barOneStyle.innerText = `${newHeight1}`;
            barTwoStyle.innerText = `${newHeight2}`;
            barOneStyle.style.height = `${newHeight1}px`;
            barTwoStyle.style.height = `${newHeight2}px`;
          }, (i*1500)/speed);
        }
      }
      setTimeout(()=>{
        this.array=clone;
        this.start=false;
      },(this.animations.length*1500)/speed)
    },
    bubbleSort(){
      this.animations=[];
      let clone=this.array.slice();
      getbubbleSort(clone,this.animations);
      let speed= this.valeur > 25 ? 750 : this.valeur;
      for(let i =0; i<this.animations.length;i++){
        const div=document.querySelectorAll('.arrayElement');
        const isColorChange = i % 3 !== 2;
        if (isColorChange) {
          const [barOneIdx, barTwoIdx] = this.animations[i];
          const barOneStyle = div[barOneIdx].style;
          const barTwoStyle = div[barTwoIdx].style;
          const color = i % 3 === 0 ? 'red' : 'turquoise';
          setTimeout(() => {
            barOneStyle.backgroundColor = color;
            barTwoStyle.backgroundColor = color;
          }, (i*1500)/speed);
        } else {
          setTimeout(() => {
            const [barOneIdx, barTwoIdx] = this.animations[i];
            const [swap1, newHeight1] = barOneIdx;
            const [swap2, newHeight2] = barTwoIdx;
            const barOneStyle = div[swap1];
            const barTwoStyle = div[swap2];
            barOneStyle.innerText = `${newHeight1}`;
            barTwoStyle.innerText = `${newHeight2}`;
            barOneStyle.style.height = `${newHeight1}px`;
            barTwoStyle.style.height = `${newHeight2}px`;
          }, (i*1500)/speed);
        }
      }
      setTimeout(()=>{
        this.array=clone;
        this.start=false;
      },(this.animations.length*1500)/speed)
    },
  },
  mounted:function(){
    this.valeur=70;
    this.getArray(this.valeur);
  }
};
</script>
<style scoped>
.active {
  color: rgb(192, 57, 140);
}
.disable {
  display: none;
}
.sort {
  min-height: 90vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: rgb(230, 230, 230);
}
.toolbar {
  width: 100%;
  height: 8vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #201f32;
  color: #fff;
  font-weight: 500;
}
.separator {
  width: 2px;
  height: 50%;
  background: #000;
}
.sizespeed {
  display: flex;
  flex-direction: column;
}
.newarray,
.merge,
.quick,
.heap,
.bubble,
.start {
  cursor: pointer;
}
.newarray:hover,
.merge:hover,
.quick:hover,
.heap:hover,
.bubble:hover,
.start:hover {
  color: #03a9f4;
}
.content {
  width: 100%;
  min-height: 82vh;
  display: flex;
  justify-content: center;
  text-align: center;
}
.arrayElement {
  padding-top: 7px;
  font-family: sans-serif;
  font-weight: 700;
  display: inline-block;
}
</style>